import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

  export class CrystalClearFrontUrlETicket extends AsbCCUrl {
  static readonly NEW_ETICKET: PageDescription = {
    label: 'page_title.new-eticket.title',
    path: 'eticket/new',
    icon: 'fas fa-receipt',
    roles: CCRoles.ROLES_NEW_ETICKET
  };
  static readonly LIST_ETICKET: PageDescription = {
    label: 'page_title.list-eticket.title',
    path: 'eticket/list',
    icon: 'fas fa-table-list',
    roles: CCRoles.ROLES_LIST_ETICKET
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlETicket.NEW_ETICKET,
    CrystalClearFrontUrlETicket.LIST_ETICKET,
  ];

}

